"use client";

import { FC } from "react";

import { SignupFlowSlug } from "libs/state/src/lib/stores/signupFlow/constants";
import {
  SimpleProgressSteps,
} from "apps/website/components/feature/Navigation/SimpleProgressSteps/SimpleProgressSteps";
import {
  signupSteps,
} from "apps/website/components/feature/Navigation/SimpleProgressSteps/signupSteps";

interface ProgressStepsProps {
  hideProgressSteps: boolean | undefined;
  pathname: SignupFlowSlug;
}

export const ProgressSteps: FC<ProgressStepsProps> = ({
  hideProgressSteps = false,
  pathname,
}) => {
  if (hideProgressSteps) {
    return null;
  }

  return (
    <div className="bg-white">
      <div className="flex justify-center flex-col fixed top-[var(--header-height-mobile)] xl:top-[var(--header-height-desktop)] w-full z-20 left-1/2 -translate-x-1/2 px-14 lg:px-0 mx-auto bg-white">
        <SimpleProgressSteps
          steps={signupSteps}
          currentSlug={pathname}
          hideLabels={true}
        />
      </div>
    </div>
  );
};
